import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Fetches whether the current user is a department manager. Used to gate UI
 * elements like the "Leave Approvals" nav link and the pending-approvals
 * badge for non-admin managers.
 *
 * Admins don't need this to see the same UI — their role flag already opens
 * those paths. But it's still called for admins so downstream code can
 * treat "is approver" uniformly (admin || isManager).
 */
export function useManagerStatus() {
  const [isManager, setIsManager] = useState(false);
  const [managedDepartmentIds, setManagedDepartmentIds] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/users/me/manager-status')
      .then(r => {
        if (cancelled) return;
        setIsManager(!!r.data?.isManager);
        setManagedDepartmentIds(r.data?.managedDepartmentIds || []);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setIsManager(false);
        setManagedDepartmentIds([]);
        setLoaded(true);
      });
    return () => { cancelled = true; };
  }, []);

  return { isManager, managedDepartmentIds, loaded };
}

export default useManagerStatus;
